import { render, staticRenderFns } from "./link_area.vue?vue&type=template&id=0a30f5d1&scoped=true&"
import script from "./link_area.vue?vue&type=script&lang=js&"
export * from "./link_area.vue?vue&type=script&lang=js&"
import style0 from "./link_area.vue?vue&type=style&index=0&id=0a30f5d1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a30f5d1",
  null
  
)

export default component.exports